import React, { useState } from "react";
import "./Courses.css";
import {
    FaArrowRight,
    FaClock,
    FaLaptop,
    FaPhoneAlt,
    FaTimes,
} from "react-icons/fa";
import PricingCard from "./PricingCard";

const Courses = () => {
    const [mode, setMode] = useState("Online");
    const [isAnimating, setIsAnimating] = useState(false);

    // Phone number popup state
    const [selectedCourse, setSelectedCourse] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [phoneError, setPhoneError] = useState("");
    const [showCurriculum, setShowCurriculum] = useState(false);

    const duration = "6 months";

    const handleToggle = (newMode) => {
        if (newMode === mode) return;

        setIsAnimating(true);

        setTimeout(() => {
            setMode(newMode);
            setIsAnimating(false);
        }, 300);
    };

    // Open phone number popup
    const handleCurriculumClick = (course) => {
        setSelectedCourse(course);
        setPhoneNumber("");
        setPhoneError("");
        setShowCurriculum(false);
    };

    // Close popup
    const closePopup = () => {
        setSelectedCourse(null);
        setPhoneNumber("");
        setPhoneError("");
        setShowCurriculum(false);
    };

    // Submit phone number
    const handlePhoneSubmit = (e) => {
        e.preventDefault();

        const cleanPhone = phoneNumber.replace(/\D/g, "");

        if (cleanPhone.length !== 10) {
            setPhoneError("Please enter a valid 10-digit phone number.");
            return;
        }

        setPhoneError("");
        setShowCurriculum(true);
    };

    // Open correct curriculum PDF
    const handleViewCurriculum = () => {
        if (!selectedCourse) return;

        const pdf =
            selectedCourse === "Python Full Stack"
                ? "/pdfs/python_fullstack_prt_academy.pdf"
                : "/pdfs/java_fullstack_prt_academy.pdf";

        window.open(pdf, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="courses-container">

            {/* =========================
                TITLE
            ========================= */}

            <h2 className="title">
                Courses You Can Choose
            </h2>


            {/* =========================
                ONLINE / CLASSROOM TOGGLE
            ========================= */}

            <div className="course-toggle">

                <button
                    className={mode === "Online" ? "active" : ""}
                    onClick={() => handleToggle("Online")}
                >
                    Online
                </button>

                <button
                    className={mode === "Offline" ? "active" : ""}
                    onClick={() => handleToggle("Offline")}
                >
                    In-Classroom
                </button>

            </div>


            {/* =========================
                COURSE CARDS
            ========================= */}

            <div
                className={`course-cards ${
                    isAnimating ? "fade-out" : "fade-in"
                }`}
            >

                {/* =========================
                    PYTHON FULL STACK
                ========================= */}

                <div className="course-card glass purple">

                    <p className="course-label">
                        COURSE 1
                    </p>

                    <h3>
                        Python Full Stack
                    </h3>

                    <p className="meta">
                        <FaClock />
                        {duration}
                    </p>

                    <p className="meta">
                        <FaLaptop />
                        10+ real time projects
                    </p>


                    {/* PHONE NUMBER BUTTON */}

                    <button
                        type="button"
                        className="curriculum-trigger"
                        onClick={() =>
                            handleCurriculumClick(
                                "Python Full Stack"
                            )
                        }
                    >
                        <FaPhoneAlt />

                        <span>
                            Get Curriculum
                        </span>

                        <FaArrowRight />
                    </button>


                    {/* COURSE ICONS */}

                    <div className="icons">

                        <img
                            src="/images/icons8-java-64.png"
                            alt="Java Full Stack Development"
                            className="float"
                        />

                        <img
                            src="/images/icons8-python-96.png"
                            alt="Python Full Stack Development"
                            className="float delay1 rotate"
                        />

                        <img
                            src="/images/icons8-css-96.png"
                            alt="Frontend Development"
                            className="float delay2"
                        />

                    </div>

                </div>


                {/* =========================
                    JAVA FULL STACK
                ========================= */}

                <div className="course-card glass blue">

                    <p className="course-label">
                        COURSE 2
                    </p>

                    <h3>
                        Java Full Stack
                    </h3>

                    <p className="meta">
                        <FaClock />
                        {duration}
                    </p>

                    <p className="meta">
                        <FaLaptop />
                        10+ real time projects
                    </p>


                    {/* PHONE NUMBER BUTTON */}

                    <button
                        type="button"
                        className="curriculum-trigger"
                        onClick={() =>
                            handleCurriculumClick(
                                "Java Full Stack"
                            )
                        }
                    >
                        <FaPhoneAlt />

                        <span>
                            Get Curriculum
                        </span>

                        <FaArrowRight />
                    </button>


                    {/* COURSE ICONS */}

                    <div className="icons">

                        <img
                            src="/images/icons8-java-64.png"
                            alt="Java Full Stack Development"
                            className="float"
                        />

                        <img
                            src="/images/icons8-python-96.png"
                            alt="Python Full Stack Development"
                            className="float delay1 rotate"
                        />

                        <img
                            src="/images/icons8-css-96.png"
                            alt="Frontend Development"
                            className="float delay2"
                        />

                    </div>

                </div>

            </div>


            {/* =========================
                PRICING / REFUND
            ========================= */}

            <PricingCard mode={mode} />


            {/* ==================================================
                PHONE NUMBER MODAL
            ================================================== */}

            {selectedCourse && (
                <div
                    className="curriculum-modal-overlay"
                    onClick={closePopup}
                >

                    <div
                        className="curriculum-modal"
                        onClick={(e) =>
                            e.stopPropagation()
                        }
                    >

                        {/* CLOSE */}

                        <button
                            type="button"
                            className="curriculum-close"
                            onClick={closePopup}
                            aria-label="Close"
                        >
                            <FaTimes />
                        </button>


                        {!showCurriculum ? (

                            <>
                                {/* HEADER */}

                                <div className="curriculum-modal-icon">
                                    <FaPhoneAlt />
                                </div>

                                <p className="curriculum-modal-label">
                                    {selectedCourse}
                                </p>

                                <h3>
                                    Get Your Course Curriculum
                                </h3>

                                <p className="curriculum-modal-description">
                                    Enter your phone number to
                                    access the detailed{" "}
                                    {selectedCourse} curriculum.
                                </p>


                                {/* PHONE FORM */}

                                <form
                                    onSubmit={
                                        handlePhoneSubmit
                                    }
                                >

                                    <div className="phone-input-wrapper">

                                        <span className="phone-code">
                                            +91
                                        </span>

                                        <input
                                            type="tel"
                                            value={phoneNumber}
                                            onChange={(e) => {
                                                const value =
                                                    e.target.value
                                                        .replace(
                                                            /\D/g,
                                                            ""
                                                        )
                                                        .slice(
                                                            0,
                                                            10
                                                        );

                                                setPhoneNumber(
                                                    value
                                                );

                                                if (
                                                    phoneError
                                                ) {
                                                    setPhoneError(
                                                        ""
                                                    );
                                                }
                                            }}
                                            placeholder="Enter 10-digit mobile number"
                                            maxLength="10"
                                            inputMode="numeric"
                                            autoComplete="tel"
                                            required
                                        />

                                    </div>


                                    {phoneError && (
                                        <p className="phone-error">
                                            {phoneError}
                                        </p>
                                    )}


                                    <button
                                        type="submit"
                                        className="curriculum-submit"
                                    >
                                        Continue
                                        <FaArrowRight />
                                    </button>

                                </form>

                            </>

                        ) : (

                            <>
                                {/* SUCCESS */}

                                <div className="curriculum-success-icon">
                                    ✓
                                </div>

                                <p className="curriculum-modal-label">
                                    CURRICULUM READY
                                </p>

                                <h3>
                                    {selectedCourse}
                                </h3>

                                <p className="curriculum-modal-description">
                                    Your course curriculum is
                                    ready to view.
                                </p>


                                <button
                                    type="button"
                                    className="curriculum-submit"
                                    onClick={
                                        handleViewCurriculum
                                    }
                                >
                                    View Curriculum
                                    <FaArrowRight />
                                </button>

                            </>

                        )}

                    </div>

                </div>
            )}

        </div>
    );
};

export default Courses;